import { Routes, Route, useNavigate } from 'react-router-dom'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import DashboardRoutesModel from './model/dashboard'
import Lost from '@/components/default/lost'
import UnderConstruction from '@/components/default/under-construction'
import LoginDashboard from '@/pages/login'
import { AppDispatch, RootState } from '@/store/store'
import { getSession } from '@/services/session/session'
import { login } from '@/store/features/auth'
import { verifyToken } from '@/services/api/auth/auth'
import Toast from '@/components/elements/toast'
import logoutDashboard from '@/components/shared/close'
import OrderSocketListener from '@/services/sockets/OrderSocketListener'
import { toggleNotifiedActive } from '@/store/features/notifications'

const ControllRoutes: React.FC = () => {
	const { token, id, data } = useSelector((state: RootState) => state.auth)
	const sessionRefrest = useSelector(
		(state: RootState) => state.state.sessionRefrest
	)
	const isSession = !!(token && id && data)
	const dispatch = useDispatch<AppDispatch>()
	const navigate = useNavigate()

	const validateTokenFn = async () => {
		if (token) {
			const response = await verifyToken(token)

			if (response?.status === 500 || response?.status === 401) {
				Toast({
					type: 'error',
					message:
						response?.status === 500
							? 'Error interno, no se pudo validar al usuario'
							: 'La session del usuario caduco',
				})
				logoutDashboard(
					dispatch,
					navigate,
					'Vuelve a ingresar para validar el usuario'
				)
				return
			}
		}
		return
	}

	useEffect(() => {
		const unlockAudio = () => {
			const audio = new Audio()
			audio.play().catch(() => {})
			window.removeEventListener('click', unlockAudio)
		}
		window.addEventListener('click', unlockAudio)

		return () => {
			window.removeEventListener('click', unlockAudio)
		}
	}, [])

	useEffect(() => {
		const unlockSound = () => {
			const a = new Audio()
			a.play().catch(() => {})
			dispatch(toggleNotifiedActive())
			window.removeEventListener('click', unlockSound)
		}

		window.addEventListener('click', unlockSound)

		return () => {
			window.removeEventListener('click', unlockSound)
		}
	}, [])

	useEffect(() => {
		validateTokenFn()
	}, [sessionRefrest])

	useEffect(() => {
		const sessionData = getSession()
		if (!sessionData) return
		dispatch(
			login({
				token: sessionData.token,
				id: sessionData.id,
				data: sessionData.data,
			})
		)
	}, [])

	return (
		<>
			{isSession && (
				<OrderSocketListener token={token ?? ''} dispacth={dispatch} />
			)}
			<Routes>
				{isSession && data && DashboardRoutesModel({ isSession, data })}
				{!isSession && <Route path='/' element={<LoginDashboard />} />}

				<Route path='*' element={isSession ? <Lost /> : <LoginDashboard />} />
				{isSession && (
					<Route path='/under-construction' element={<UnderConstruction />} />
				)}
			</Routes>
		</>
	)
}

export default ControllRoutes
